import React from 'react';

class SpecialBulletin extends React.Component {
	render() {
		return(

			<div>
				<div className="navbar-top">
		          <div className="site-brand">
		            <div className="side-nav-panel-left">
			            <a href="/"> 
			              <i className="fa fa-arrow-left" style={{fontSize: '21px',color: '#F0592D', paddingRight: '8px'}}></i>
			            </a>
		            </div>
		          </div>
		          <div className="site-brand">
		            <a href="/"> 
		              <h2><span className="st2">XPRESS</span><span className="st1">Lite</span></h2>
		            </a>
		          </div>
		          
		        </div>
                <div className="pages section">
					<div className="container">
						<div className="assetsdownload">
							<div className="assetsdownload-content">
								
                    <h6 className="heading-top">Special Bulletins</h6>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://www.indianoilxpress.com/Uploads/XpressNews/SpecialXpress_HRidaySe2023.pdf">
					 
					 <span className="bulletint_type">SpecialXpress, Monday 20, 2023 - Message from Director HR</span>
                        </a>
                      </div>
				
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_International_Human_Resources_Day_2022.pdf">
					 
					 <span className="bulletint_type">SpecialXpress International Human Resources Day 2022</span>
                        </a>
                      </div>
				
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_13_April_2022.pdf">
					 
					 <span className="bulletint_type">Special Xpress 13 April, 2022</span>
                        </a>
                      </div>
				
                    </div>


                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SW@DHYAYA_PULSE_APRIL_2022_EDITION.pdf">
					 
					 <span className="bulletint_type">SW@DHYAYA PULSE APRIL 2022 EDITION</span>
                        </a>
                      </div>
				
                    </div>

                    
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_8_March_2022.pdf">
					 
					 <span className="bulletint_type">Special Xpress 8 March, 2022</span>
                        </a>
                      </div>
				
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_GOQii_Corporate_Fitness_Challenge.pdf">
					 
					 <span className="bulletint_type">Special Xpress - GOQii Corporate Fitness Challenge</span>
                        </a>
                      </div>
				
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Special_Xpress_IndianOil_Tops_BusinessWorld_Real_500_Rankings.pdf">
					 
					 <span className="bulletint_type">Special Xpress - IndianOil Tops BusinessWorld Real 500 Rankings</span>
                        </a>
                      </div>
				
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SW@DHYAYA-JOY-OF-LEARNING-1.5-Million-Milestone.pdf">
					 
					 <span className="bulletint_type">SW@DHYAYA JOY OF LEARNING _ 1.5 Million Milestone</span>
                        </a>
                      </div>
				
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Synopsis_of_Union_Budget_2022-23.pdf">
					 
					 <span className="bulletint_type">Synopsis of Union Budget 2022-23</span>
                        </a>
                      </div>
				
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Straight_Talk_by_Chairman_IndianOil_November_2021.pdf">
					 
					 <span className="bulletint_type">Straight Talk by Chairman, IndianOil: November 2021</span>
                        </a>
                      </div>
				
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_November_15_2021.pdf">
					 
					 <span className="bulletint_type">SpecialXpress, November 15, 2021</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Celebrating_20_Years_of_IndianOil_Mauritius_Limited.pdf">
					 
					 <span className="bulletint_type">Celebrating 20 Years of IndianOil (Mauritius) Limited</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Straight_Talk_by_Chairman_IndianOil_October_2021_edition.pdf">
					 
					 <span className="bulletint_type">Straight Talk by Chairman, IndianOil _ October 2021 edition</span>
                        </a>
                      </div>
				
                    </div>
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/HRiday_Se..by_Director_HR_IndianOil.pdf">
					 
					 <span className="bulletint_type">HRiday Se... by Director (HR), IndianOil</span>
                        </a>
                      </div>
				
                    </div>
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Celebration-of-World-Rhino-Day.pdf">
					 
					 <span className="bulletint_type">Celebration of World Rhino Day</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Glimpses_of_62nd_IndianOil_Day_Celebrations.pdf">
					 
					 <span className="bulletint_type">Glimpses of 62nd IndianOil Day Celebrations</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Let_Us_Sing_The_National_Anthem.pdf">
					 
					 <span className="bulletint_type">Let Us Sing The National Anthem</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/One_Million_Milestone_on_SW@DHYAYA.pdf">
					 
					 <span className="bulletint_type">One Million Milestone on SW@DHYAYA</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Vyakhyan_IndianOil_LEADTALKS_14th_Edition_on_4th_June_2021.pdf">
					 
					 <span className="bulletint_type">Vyakhyan IndianOil LEADTALKS 14th Edition on 4th June 2021</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_15_May_2021_Mission_Vaccination_@_IndianOil.pdf">
					 
					 <span className="bulletint_type">Mission Vaccination @ IndianOil</span>
                        </a>
                      </div>
				
                    </div>
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/IndianOil_Covid_Coordination_Centres_Updated_Contact_Details.pdf">
					 
					 <span className="bulletint_type">List of IndianOil Covid Coordinators</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Vyakhyan_IndianOil_LEADTALKS_13th_Edition_on_27th_April_2021.pdf">
					 
					 <span className="bulletint_type">Vyakhyan IndianOil LEADTALKS - 13th Edition on 27th April, 2021</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Appeal_for_Plasma_Donation.pdf">
					 
					 <span className="bulletint_type">Appeal for Plasma Donation</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Swadhyaya_Pulse_Newsletter_issue_6_v3.pdf">
					 
					 <span className="bulletint_type">SWADHYAYA PULSE - 6th Edition, March 2021</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_Mobile_Application_for_Safety_of_Employees.pdf">
					 
					 <span className="bulletint_type">Mobile Application for Safety of Employees</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/IndianOil_Covid_Analysis_Volume_9.pdf">
					 
					 <span className="bulletint_type">IndianOil Covid Analysis (Volume - 9)</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_on_COVID_19_Awareness.pdf">
					 
					 <span className="bulletint_type">COVID 19 Awareness</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SW@DHYAYA_PULSE_5th_Edition.pdf">
					 
					 <span className="bulletint_type">SW@DHYAYA PULSE (5th Edition)</span>
                        </a>
                      </div>
				
                    </div>

					
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/sw@dhyaya_deal_3_coming_soon.pdf">
					 
					 <span className="bulletint_type">SW@DHYAYA : DEAL - 3 Coming Soon...</span>
                        </a>
                      </div>
				
                    </div>



					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/sw@dhyaya_deal_result_part_ii.pdf">
					 
					 <span className="bulletint_type">SW@DHYAYA: DEAL Result Part II</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/MOMENT_61st_IndianOil_Day_Celebrations_at_Corporate_Office.pdf">
					 
					 <span className="bulletint_type">M O M E N T S  :  61st  IndianOil Day Celebrations at Corporate Office</span>
                        </a>
                      </div>
				
                    </div>


					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_7th_Edition_of_Vyakhyan_LEAD_Talk.pdf">
					 
					 <span className="bulletint_type">IndianOil Covid Analysis Volume 1</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/SpecialXpress_7th_Edition_of_Vyakhyan_LEAD_Talk.pdf">
					 
					 <span className="bulletint_type">IndianOil LEAD Talks Seventh Edition</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Drop_And_Learn_Everything_2nd_Edition.pdf">
					 
					 <span className="bulletint_type">Swadhyaya : Drop Everything And Learn - 2nd Edition</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/DEAL_Congratulatory_Note_DHR_Revision1.pdf">
					 
					 <span className="bulletint_type">Swadhyaya : Drop Everything And Learn - 1st Edition</span>
                        </a>
                      </div>
				
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/Swadhyaya_Pulse_Newsletter_3rd_edition.pdf">
					 
					 <span className="bulletint_type">Swadhyaya Pulse Edition 3</span>
                        </a>
                      </div>
				
                    </div>


					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/HRiday_Se_07_0_20.pdf">
					 
					 <span className="bulletint_type">HRiday Se...from Director (HR)</span>
                        </a>
                      </div>
				
                    </div>
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/Straight_Talk_Final_1.mp4">
					 
					 <span className="bulletint_type">"Straight Talk" By Chairman</span>
                        </a>
                      </div>
				
                    </div>
					
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com//uploads/XpressNews/sw@dhyaya-deal-the-countdown-begins.pdf">
					 
					 <span className="bulletint_type">SW@DHYAYA: DEAL... the countdown begins</span>
                        </a>
                      </div>
				
                    </div>

					



					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com//uploads/XpressNews/sw@dhyaya-deal-2-days-to-go.pdf">
					 
					 <span className="bulletint_type">SW@DHYAYA: DEAL... 2 days to go</span>
                        </a>
                      </div>
				
                    </div>


			
</div>
</div>
</div>
</div>
		  
				<div id="fakeLoader"></div>

				<div className="footer" style={{position:'relative', width:'100%', bottom:'0',}}>
					<div className="container">
					<div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				
						</div>
					</div>
				</div>
</div>
		

		)
	}
}

export default SpecialBulletin;


// WEBPACK FOOTER //
// ./src/specialBulletin.js